// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/avenir-next/AvenirNextLTPro-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/avenir-next/AvenirNextLTPro-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/avenir-next/AvenirNextLTPro-It.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Jost:wght@200;300;400;500;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.1 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.visible {
  visibility: visible;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  inset: 0px;
}
.left-0 {
  left: 0px;
}
.left-\\[50\\%\\] {
  left: 50%;
}
.top-0 {
  top: 0px;
}
.top-\\[80px\\] {
  top: 80px;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-16 {
  margin-top: 4rem;
  margin-bottom: 4rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-\\[2px\\] {
  margin-bottom: 2px;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.flex {
  display: flex;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.size-\\[24rem\\] {
  width: 24rem;
  height: 24rem;
}
.h-\\[300px\\] {
  height: 300px;
}
.h-\\[30rem\\] {
  height: 30rem;
}
.h-\\[400px\\] {
  height: 400px;
}
.h-\\[90\\%\\] {
  height: 90%;
}
.h-full {
  height: 100%;
}
.w-\\[300px\\] {
  width: 300px;
}
.w-\\[310px\\] {
  width: 310px;
}
.w-\\[50\\%\\] {
  width: 50%;
}
.w-\\[500px\\] {
  width: 500px;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.flex-1 {
  flex: 1 1;
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.resize {
  resize: both;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-rows-6 {
  grid-template-rows: repeat(6, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-x-0 {
  column-gap: 0px;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-x-6 {
  column-gap: 1.5rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-3 {
  row-gap: 0.75rem;
}
.gap-y-6 {
  row-gap: 1.5rem;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.bg-brownBg {
  --tw-bg-opacity: 1;
  background-color: rgb(248 243 237 / var(--tw-bg-opacity));
}
.bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(169 78 77 / var(--tw-bg-opacity));
}
.bg-primaryDark {
  --tw-bg-opacity: 1;
  background-color: rgb(98 46 45 / var(--tw-bg-opacity));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-opacity-60 {
  --tw-bg-opacity: 0.6;
}
.bg-opacity-75 {
  --tw-bg-opacity: 0.75;
}
.bg-cover {
  background-size: cover;
}
.bg-center {
  background-position: center;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.object-cover {
  object-fit: cover;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-\\[10\\%\\] {
  padding-left: 10%;
  padding-right: 10%;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-44 {
  padding-top: 11rem;
  padding-bottom: 11rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.text-center {
  text-align: center;
}
.text-justify {
  text-align: justify;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.font-bold {
  font-weight: 700;
}
.font-light {
  font-weight: 300;
}
.font-semibold {
  font-weight: 600;
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-primary {
  --tw-text-opacity: 1;
  color: rgb(169 78 77 / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline {
  outline-style: solid;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
  font-size: 15px;
}

:root {
  --clr-primary: #a94e4d;
  --clr-primary-dark: #622e2d;
  --clr-primary-dark200: #c28382;
  --clr-secondary: #f8f3ed;
  --clr-brown: #a8783e;
  --clr-main-bg: #fcfbf9;
  --clr-dark: #14142b;
  --clr-black: #000;
  --clr-gray900: #262338;
  --clr-gray800: #4e4b66;
  --clr-gray600: #6e7191;
  --clr-gray500: #a0a3bd;
  --clr-gray400: #c4c4c4;
  --clr-gray300: #eff0f6;
  --clr-gray200: #f7f7fc;
  --clr-gray: #d9dbe9;
  --clr-light: #fcfcfc;
  --clr-error-dark: #e40173;
  --clr-error: #ffe5f2;
  --clr-success-dark: #00994d;
  --clr-success: #e5fff2;
  --clr-warning-dark: #6a5300;
  --clr-warning: #fefee5;
  --clr-blue: #4267b2;
  --clr-error-bg: #fff2f9;
}

@font-face {
  font-family: "Avenir Next";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("opentype");
}

* {
  font-family: "Avenir Next", -apple-system, BlinkMacSystemFont, "Segoe UI",
    "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
    "Helvetica Neue", sans-serif;
}

body {
  margin: 0;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: var(--clr-main-bg);
  overflow-x: hidden;
  letter-spacing: 0.05rem;
}

html {
  /* scrollbar-color: #44ee4e; */
  scrollbar-track-color: transparent;
  /* scrollbar-arrow-color: var(--clr-dark); */
  scrollbar-width: thin;
}

html::-webkit-scrollbar {
  width: 0.75rem;
}

html::-webkit-scrollbar-track {
  background-color: transparent;
}

html::-webkit-scrollbar-thumb {
  background: var(--clr-primary-dark);
  border-radius: 3rem;
}

body::-webkit-scrollbar-track {
  background-color: var(--clr-primary);
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

header {
  position: relative;
  z-index: 13 !important;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 400;
  color: var(--clr-dark);
  font-family: "Jost" !important;
}

/* SWIPER */

.swiper-pagination-bullet {
  background: #fff !important;
  opacity: 1 !important;
}

.swiper-pagination-bullet-active {
  background: var(--clr-primary) !important;
}

.swiper-button-next,
.swiper-button-prev {
  color: var(--clr-light) !important;
}

.swiper-button-next:after,
.swiper-button-prev:after {
  font-weight: bold !important;
  font-size: 1.5rem !important;
}

/* END SWIPER */

button {
  display: flex;
  align-items: center;
  outline: none;
  border: none;
  padding: 1.25em 1.75em;
  border-radius: 3em;
  font-family: "Avenir Next";
  letter-spacing: 0.05rem;
  cursor: pointer;
}

button:disabled {
  opacity: 0.75;
}

.btn-minus,
.btn-add {
  width: 2rem !important;
  position: relative;
  height: 2rem !important;
  padding: 0;
  background: var(--clr-gray300);
}

.btn-add::after,
.btn-add::before,
.btn-minus::after {
  content: "";
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  position: absolute;
  border-radius: 3em;
  background: var(--clr-dark);
  width: 8px;
  height: 2px;
}

.btn-add::after {
  transform: rotate(90deg);
}

input {
  letter-spacing: 0.05rem;
  font-family: "Avenir Next";
}

/* hide arrow nav on input number */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.btn {
  background: var(--clr-primary);
  color: var(--clr-light);
}

.btn .arrow {
  width: 0.5rem;
  display: block;
}

.btn.outline {
  border: 0.15rem solid var(--clr-primary);
  background: transparent;
}

p {
  color: var(--clr-dark);
}

a {
  text-decoration: none;
  color: var(--clr-dark);
}

ul {
  list-style: none;
}

.container {
  width: 80%;
  max-width: 1200px;
  margin: 0 auto;
}
.error-text {
  color: var(--clr-error-dark);
  font-family: "Jost";
  font-weight: 600;
  font-size: 0.8rem;
}

.text-center {
  text-align: center;
}

/* checkbox */

.checkbox-container {
  width: 100%;
  display: flex;
  align-items: center;
}

.checkbox-container input[type="checkbox"] {
  display: none;
}

.checkbox-container input[type="checkbox"]:checked ~ .checkbox-button {
  background: var(--clr-primary);
}

.checkbox-container
  input[type="checkbox"]:checked
  ~ .checkbox-button
  .tick-mark {
  display: flex;
}

.checkbox-container input[type="checkbox"]:checked ~ .checkbox-name {
  color: var(--clr-primary);
}

.checkbox-button {
  display: block;
  width: 100%;
  max-width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  margin-right: 0.5rem;
  background: var(--clr-gray);
}

.checkbox-button .tick-mark {
  display: none;
  width: 0.5rem;
  height: 0.5rem;
  bottom: -0.3rem;
  left: -0.15rem;
  margin-bottom: 0;
}

/* toggle */
.toggle-main-container {
  position: relative;
  width: 100%;
  max-width: 5.5rem;
}

.toggle-container {
  display: block;
  width: 100%;
  height: 2.5rem;
  cursor: pointer;
  border-radius: 3em;
  padding: 1em;
  background: var(--clr-gray);
}

.toggle-input {
  z-index: 2;
  display: none;
  position: absolute;
}

.toggle {
  height: 80%;
  width: 2rem;
  border-radius: 50%;
  left: 0.3rem;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  background: var(--clr-light);
  transition: 0.5s;
}

.toggle-input:checked ~ .toggle-container {
  background: var(--clr-primary);
}

.toggle-input:checked ~ .toggle-container .toggle {
  left: 58%;
}

/* .flex-row {
  display: flex;
  flex-direction: row;
}

.flex-column {
  display: flex;
  flex-direction: column;
} */

/* cross mark */
.cross-mark {
  display: flex;
  position: relative;
  width: 1.5rem;
  margin-left: 0.5rem;
  height: 1.5rem;
  z-index: 1001;
  cursor: pointer;
}

.cross-mark.primary::before,
.cross-mark.primary::after {
  background: var(--clr-primary);
}

.cross-mark::after,
.cross-mark::before {
  content: "";
  position: absolute;
  width: 0.1rem;
  height: 1rem;
  border-radius: 3em;
  background: var(--clr-dark);
}
.cross-mark::after {
  transform: rotate(45deg);
}

.cross-mark::before {
  transform: rotate(-45deg);
}

/* tick mark */
.tick-mark {
  position: relative;
  display: block;
  width: 1rem;
  height: 1rem;
  margin-bottom: 0.25rem;
}

.tick-mark::before,
.tick-mark::after {
  content: "";
  position: absolute;
  left: 0;
  background: var(--clr-light);
  transform: translateX(10px) rotate(-45deg);
  transform-origin: left bottom;
  border-radius: 3em;
}

.tick-mark::before {
  top: 50%;
  height: 50%;
  width: 0.1rem;
}

.tick-mark::after {
  bottom: 0;
  height: 0.1rem;
  width: 100%;
}

/* loading animation */
.loading-animation {
  display: block;
  position: relative;
  width: 1.5rem;
  height: 1.5rem;
  left: -1rem;
}

.loading-animation span,
.loading-animation div {
  display: block;
  position: absolute;
  width: 1.5rem;
  height: 1.5rem;
  border: 0.2rem solid var(--clr-dark);
  border-radius: 50%;
  animation: loading-animation 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: var(--clr-dark) transparent transparent transparent;
}

.loading-animation span:nth-child(1),
.loading-animation div:nth-child(1) {
  animation-delay: -0.45s;
}
.loading-animation span:nth-child(2),
.loading-animation div:nth-child(2) {
  animation-delay: -0.3s;
}
.loading-animation span:nth-child(3),
.loading-animation div:nth-child(3) {
  animation-delay: -0.15s;
}

.loading-container-text {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 1.25rem;
  padding: 2em 0;
}

.loading-container-text .loading-animation {
  margin-bottom: 3rem;
}

.loading-container-text .loading-animation span {
  display: block;
  position: absolute;
  width: 3rem;
  height: 3rem;
  border: 0.5rem solid var(--clr-primary);
  border-radius: 50%;
  border-color: var(--clr-primary) transparent transparent transparent;
}

.loading-container-text.h-full {
  height: 100vh;
}

@keyframes loading-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.skeleton-card {
  background-color: #fff5;
  height: 2rem;
  overflow: hidden;
  position: relative;
  width: 100%;
  border-radius: 1em;
}

.skeleton::after,
.skeleton-card::after {
  display: block;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  transform: translateX(-100%);

  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.74),
    transparent
  );

  animation: loadingSkeleton 0.8s infinite;
}

.skeleton {
  background: #efefef70;
  width: 7rem;
  height: 1rem;
  border-radius: 0.5em;
  overflow: hidden;
  position: relative;
  margin-top: 0.7rem;
}

@keyframes loadingSkeleton {
  100% {
    transform: translateX(100%);
  }
}

/* google mAPS

.gm-style .gm-style-iw-t {
  bottom: 4rem !important;
}

*/

.gm-ui-hover-effect,
.gm-ui-hover-effect > span {
  display: none !important;
}

/* MANSORY */
.my-masonry-grid { /* Not needed if autoprefixing */ /* Not needed if autoprefixing */
  display: flex;
  width: auto;
}
.my-masonry-grid_column {
  padding-left: 30px; /* gutter size */
  background-clip: padding-box;
}

/* Style your items */
.my-masonry-grid_column > div {
  /* change div to reference your elements you put in <Masonry> */
  margin-bottom: 30px;
}

.loading-dot {
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-dot span {
  width: 8px;
  height: 8px;
  background: #0003;
  border-radius: 50%;
  margin: 0 0.25rem;
}

.loading-dot span:first-child {
  animation: loadingDotAnimation1 1s infinite;
}
.loading-dot span:nth-child(2) {
  animation: loadingDotAnimation2 1s infinite;
}
.loading-dot span:nth-child(3) {
  animation: loadingDotAnimation3 1s infinite;
}

@keyframes loadingDotAnimation1 {
  0% {
    opacity: 0.25;
  }
  30% {
    opacity: 1;
  }
}
@keyframes loadingDotAnimation2 {
  30% {
    opacity: 0.25;
  }
  60% {
    opacity: 1;
  }
}
@keyframes loadingDotAnimation3 {
  60% {
    opacity: 0.25;
  }
  100% {
    opacity: 1;
  }
}

.thumbs-wrapper {
  display: none;
}

.carousel-status {
  visibility: hidden;
}

.hover\\:bg-primary\\/80:hover {
  background-color: rgb(169 78 77 / 0.8);
}

.group:hover .group-hover\\:bg-opacity-0 {
  --tw-bg-opacity: 0;
}

.group:hover .group-hover\\:opacity-0 {
  opacity: 0;
}

@media (min-width: 640px) {

  .sm\\:hidden {
    display: none;
  }

  .sm\\:size-\\[24rem\\] {
    width: 24rem;
    height: 24rem;
  }

  .sm\\:gap-x-3 {
    column-gap: 0.75rem;
  }
}

@media (min-width: 768px) {

  .md\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .md\\:block {
    display: block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:size-\\[23rem\\] {
    width: 23rem;
    height: 23rem;
  }

  .md\\:h-\\[400px\\] {
    height: 400px;
  }

  .md\\:w-\\[371px\\] {
    width: 371px;
  }

  .md\\:w-\\[40\\%\\] {
    width: 40%;
  }

  .md\\:w-\\[400px\\] {
    width: 400px;
  }

  .md\\:max-w-\\[50\\%\\] {
    max-width: 50%;
  }

  .md\\:max-w-\\[60\\%\\] {
    max-width: 60%;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-row-reverse {
    flex-direction: row-reverse;
  }

  .md\\:items-start {
    align-items: flex-start;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:gap-x-5 {
    column-gap: 1.25rem;
  }

  .md\\:gap-y-0 {
    row-gap: 0px;
  }

  .md\\:gap-y-24 {
    row-gap: 6rem;
  }

  .md\\:gap-y-3 {
    row-gap: 0.75rem;
  }

  .md\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-\\[10\\%\\] {
    padding-left: 10%;
    padding-right: 10%;
  }

  .md\\:px-\\[20\\%\\] {
    padding-left: 20%;
    padding-right: 20%;
  }

  .md\\:py-0 {
    padding-top: 0px;
    padding-bottom: 0px;
  }
}

@media (min-width: 1024px) {

  .lg\\:size-\\[21rem\\] {
    width: 21rem;
    height: 21rem;
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-rows-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }

  .lg\\:gap-x-8 {
    column-gap: 2rem;
  }

  .lg\\:gap-y-20 {
    row-gap: 5rem;
  }
}

@media (min-width: 1280px) {

  .xl\\:size-\\[27rem\\] {
    width: 27rem;
    height: 27rem;
  }

  .xl\\:gap-x-6 {
    column-gap: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,YAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAInB;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B;EAC9B,wBAAwB;EACxB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,oBAAoB;EACpB,2BAA2B;EAC3B,sBAAsB;EACtB,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B;;8DAEsE;AACxE;;AAEA;EACE;;gCAE8B;AAChC;;AAEA;EACE,SAAS;;EAET,mCAAmC;EACnC,kCAAkC;EAClC,8BAA8B;EAC9B,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;;;;EAME,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,WAAW;;AAEX;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA,eAAe;;AAEf;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;EACV,8BAA8B;AAChC;;AAEA;;;EAGE,WAAW;EACX,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,UAAU;EACV,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA,mCAAmC;AACnC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,aAAa;;AAEb;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA;;;;;;;;GAQG;;AAEH,eAAe;AACf;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,4BAA4B;EAC5B,0CAA0C;EAC1C,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,aAAa;AACf;;AAEA;EACE,SAAS;EACT,cAAc;EACd,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,oCAAoC;EACpC,kBAAkB;EAClB,uEAAuE;EACvE,iEAAiE;AACnE;;AAEA;;EAEE,uBAAuB;AACzB;AACA;;EAEE,sBAAsB;AACxB;AACA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,4BAA4B;;EAU5B;;;;;GAKC;;EAED,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;;;;;;CAMC;;AAED;;EAEE,wBAAwB;AAC1B;;AAEA,YAAY;AACZ,mBACwB,gCAAgC,EAChC,gCAAgC;EACtD,aAAa;EACb,WAAW;AACb;AACA;EACE,kBAAkB,EAAE,gBAAgB;EACpC,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,+DAA+D;EAC/D,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAzmBA;EAAA;AA0mBA;;AA1mBA;EAAA;AA0mBA;;AA1mBA;EAAA;AA0mBA;;AA1mBA;;EAAA;IAAA;EA0mBA;;EA1mBA;IAAA,YA0mBA;IA1mBA;EA0mBA;;EA1mBA;IAAA;EA0mBA;AAAA;;AA1mBA;;EAAA;IAAA,gBA0mBA;IA1mBA;EA0mBA;;EA1mBA;IAAA;EA0mBA;;EA1mBA;IAAA;EA0mBA;;EA1mBA;IAAA;EA0mBA;;EA1mBA;IAAA,YA0mBA;IA1mBA;EA0mBA;;EA1mBA;IAAA;EA0mBA;;EA1mBA;IAAA;EA0mBA;;EA1mBA;IAAA;EA0mBA;;EA1mBA;IAAA;EA0mBA;;EA1mBA;IAAA;EA0mBA;;EA1mBA;IAAA;EA0mBA;;EA1mBA;IAAA;EA0mBA;;EA1mBA;IAAA;EA0mBA;;EA1mBA;IAAA;EA0mBA;;EA1mBA;IAAA;EA0mBA;;EA1mBA;IAAA;EA0mBA;;EA1mBA;IAAA;EA0mBA;;EA1mBA;IAAA;EA0mBA;;EA1mBA;IAAA;EA0mBA;;EA1mBA;IAAA;EA0mBA;;EA1mBA;IAAA,iBA0mBA;IA1mBA;EA0mBA;;EA1mBA;IAAA,oBA0mBA;IA1mBA;EA0mBA;;EA1mBA;IAAA,iBA0mBA;IA1mBA;EA0mBA;;EA1mBA;IAAA,iBA0mBA;IA1mBA;EA0mBA;;EA1mBA;IAAA,gBA0mBA;IA1mBA;EA0mBA;AAAA;;AA1mBA;;EAAA;IAAA,YA0mBA;IA1mBA;EA0mBA;;EA1mBA;IAAA;EA0mBA;;EA1mBA;IAAA;EA0mBA;;EA1mBA;IAAA;EA0mBA;;EA1mBA;IAAA;EA0mBA;AAAA;;AA1mBA;;EAAA;IAAA,YA0mBA;IA1mBA;EA0mBA;;EA1mBA;IAAA;EA0mBA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@import url(\"https://fonts.googleapis.com/css2?family=Jost:wght@200;300;400;500;700&display=swap\");\n\n* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n  font-size: 15px;\n}\n\n:root {\n  --clr-primary: #a94e4d;\n  --clr-primary-dark: #622e2d;\n  --clr-primary-dark200: #c28382;\n  --clr-secondary: #f8f3ed;\n  --clr-brown: #a8783e;\n  --clr-main-bg: #fcfbf9;\n  --clr-dark: #14142b;\n  --clr-black: #000;\n  --clr-gray900: #262338;\n  --clr-gray800: #4e4b66;\n  --clr-gray600: #6e7191;\n  --clr-gray500: #a0a3bd;\n  --clr-gray400: #c4c4c4;\n  --clr-gray300: #eff0f6;\n  --clr-gray200: #f7f7fc;\n  --clr-gray: #d9dbe9;\n  --clr-light: #fcfcfc;\n  --clr-error-dark: #e40173;\n  --clr-error: #ffe5f2;\n  --clr-success-dark: #00994d;\n  --clr-success: #e5fff2;\n  --clr-warning-dark: #6a5300;\n  --clr-warning: #fefee5;\n  --clr-blue: #4267b2;\n  --clr-error-bg: #fff2f9;\n}\n\n@font-face {\n  font-family: \"Avenir Next\";\n  src: url(\"./fonts/avenir-next/AvenirNextLTPro-Regular.otf\") format(\"opentype\"),\n    url(\"./fonts/avenir-next/AvenirNextLTPro-Bold.otf\") format(\"opentype\"),\n    url(\"./fonts/avenir-next/AvenirNextLTPro-It.otf\") format(\"opentype\");\n}\n\n* {\n  font-family: \"Avenir Next\", -apple-system, BlinkMacSystemFont, \"Segoe UI\",\n    \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\",\n    \"Helvetica Neue\", sans-serif;\n}\n\nbody {\n  margin: 0;\n\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: var(--clr-main-bg);\n  overflow-x: hidden;\n  letter-spacing: 0.05rem;\n}\n\nhtml {\n  /* scrollbar-color: #44ee4e; */\n  scrollbar-track-color: transparent;\n  /* scrollbar-arrow-color: var(--clr-dark); */\n  scrollbar-width: thin;\n}\n\nhtml::-webkit-scrollbar {\n  width: 0.75rem;\n}\n\nhtml::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\nhtml::-webkit-scrollbar-thumb {\n  background: var(--clr-primary-dark);\n  border-radius: 3rem;\n}\n\nbody::-webkit-scrollbar-track {\n  background-color: var(--clr-primary);\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\nheader {\n  position: relative;\n  z-index: 13 !important;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-weight: 400;\n  color: var(--clr-dark);\n  font-family: \"Jost\" !important;\n}\n\n/* SWIPER */\n\n.swiper-pagination-bullet {\n  background: #fff !important;\n  opacity: 1 !important;\n}\n\n.swiper-pagination-bullet-active {\n  background: var(--clr-primary) !important;\n}\n\n.swiper-button-next,\n.swiper-button-prev {\n  color: var(--clr-light) !important;\n}\n\n.swiper-button-next:after,\n.swiper-button-prev:after {\n  font-weight: bold !important;\n  font-size: 1.5rem !important;\n}\n\n/* END SWIPER */\n\nbutton {\n  display: flex;\n  align-items: center;\n  outline: none;\n  border: none;\n  padding: 1.25em 1.75em;\n  border-radius: 3em;\n  font-family: \"Avenir Next\";\n  letter-spacing: 0.05rem;\n  cursor: pointer;\n}\n\nbutton:disabled {\n  opacity: 0.75;\n}\n\n.btn-minus,\n.btn-add {\n  width: 2rem !important;\n  position: relative;\n  height: 2rem !important;\n  padding: 0;\n  background: var(--clr-gray300);\n}\n\n.btn-add::after,\n.btn-add::before,\n.btn-minus::after {\n  content: \"\";\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  margin: auto;\n  position: absolute;\n  border-radius: 3em;\n  background: var(--clr-dark);\n  width: 8px;\n  height: 2px;\n}\n\n.btn-add::after {\n  transform: rotate(90deg);\n}\n\ninput {\n  letter-spacing: 0.05rem;\n  font-family: \"Avenir Next\";\n}\n\n/* hide arrow nav on input number */\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.btn {\n  background: var(--clr-primary);\n  color: var(--clr-light);\n}\n\n.btn .arrow {\n  width: 0.5rem;\n  display: block;\n}\n\n.btn.outline {\n  border: 0.15rem solid var(--clr-primary);\n  background: transparent;\n}\n\np {\n  color: var(--clr-dark);\n}\n\na {\n  text-decoration: none;\n  color: var(--clr-dark);\n}\n\nul {\n  list-style: none;\n}\n\n.container {\n  width: 80%;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n.error-text {\n  color: var(--clr-error-dark);\n  font-family: \"Jost\";\n  font-weight: 600;\n  font-size: 0.8rem;\n}\n\n.text-center {\n  text-align: center;\n}\n\n/* checkbox */\n\n.checkbox-container {\n  width: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.checkbox-container input[type=\"checkbox\"] {\n  display: none;\n}\n\n.checkbox-container input[type=\"checkbox\"]:checked ~ .checkbox-button {\n  background: var(--clr-primary);\n}\n\n.checkbox-container\n  input[type=\"checkbox\"]:checked\n  ~ .checkbox-button\n  .tick-mark {\n  display: flex;\n}\n\n.checkbox-container input[type=\"checkbox\"]:checked ~ .checkbox-name {\n  color: var(--clr-primary);\n}\n\n.checkbox-button {\n  display: block;\n  width: 100%;\n  max-width: 1.25rem;\n  height: 1.25rem;\n  border-radius: 50%;\n  margin-right: 0.5rem;\n  background: var(--clr-gray);\n}\n\n.checkbox-button .tick-mark {\n  display: none;\n  width: 0.5rem;\n  height: 0.5rem;\n  bottom: -0.3rem;\n  left: -0.15rem;\n  margin-bottom: 0;\n}\n\n/* toggle */\n.toggle-main-container {\n  position: relative;\n  width: 100%;\n  max-width: 5.5rem;\n}\n\n.toggle-container {\n  display: block;\n  width: 100%;\n  height: 2.5rem;\n  cursor: pointer;\n  border-radius: 3em;\n  padding: 1em;\n  background: var(--clr-gray);\n}\n\n.toggle-input {\n  z-index: 2;\n  display: none;\n  position: absolute;\n}\n\n.toggle {\n  height: 80%;\n  width: 2rem;\n  border-radius: 50%;\n  left: 0.3rem;\n  top: 50%;\n  transform: translateY(-50%);\n  position: absolute;\n  background: var(--clr-light);\n  transition: 0.5s;\n}\n\n.toggle-input:checked ~ .toggle-container {\n  background: var(--clr-primary);\n}\n\n.toggle-input:checked ~ .toggle-container .toggle {\n  left: 58%;\n}\n\n/* .flex-row {\n  display: flex;\n  flex-direction: row;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column;\n} */\n\n/* cross mark */\n.cross-mark {\n  display: flex;\n  position: relative;\n  width: 1.5rem;\n  margin-left: 0.5rem;\n  height: 1.5rem;\n  z-index: 1001;\n  cursor: pointer;\n}\n\n.cross-mark.primary::before,\n.cross-mark.primary::after {\n  background: var(--clr-primary);\n}\n\n.cross-mark::after,\n.cross-mark::before {\n  content: \"\";\n  position: absolute;\n  width: 0.1rem;\n  height: 1rem;\n  border-radius: 3em;\n  background: var(--clr-dark);\n}\n.cross-mark::after {\n  transform: rotate(45deg);\n}\n\n.cross-mark::before {\n  transform: rotate(-45deg);\n}\n\n/* tick mark */\n.tick-mark {\n  position: relative;\n  display: block;\n  width: 1rem;\n  height: 1rem;\n  margin-bottom: 0.25rem;\n}\n\n.tick-mark::before,\n.tick-mark::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  background: var(--clr-light);\n  transform: translateX(10px) rotate(-45deg);\n  transform-origin: left bottom;\n  border-radius: 3em;\n}\n\n.tick-mark::before {\n  top: 50%;\n  height: 50%;\n  width: 0.1rem;\n}\n\n.tick-mark::after {\n  bottom: 0;\n  height: 0.1rem;\n  width: 100%;\n}\n\n/* loading animation */\n.loading-animation {\n  display: block;\n  position: relative;\n  width: 1.5rem;\n  height: 1.5rem;\n  left: -1rem;\n}\n\n.loading-animation span,\n.loading-animation div {\n  display: block;\n  position: absolute;\n  width: 1.5rem;\n  height: 1.5rem;\n  border: 0.2rem solid var(--clr-dark);\n  border-radius: 50%;\n  animation: loading-animation 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n  border-color: var(--clr-dark) transparent transparent transparent;\n}\n\n.loading-animation span:nth-child(1),\n.loading-animation div:nth-child(1) {\n  animation-delay: -0.45s;\n}\n.loading-animation span:nth-child(2),\n.loading-animation div:nth-child(2) {\n  animation-delay: -0.3s;\n}\n.loading-animation span:nth-child(3),\n.loading-animation div:nth-child(3) {\n  animation-delay: -0.15s;\n}\n\n.loading-container-text {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  font-size: 1.25rem;\n  padding: 2em 0;\n}\n\n.loading-container-text .loading-animation {\n  margin-bottom: 3rem;\n}\n\n.loading-container-text .loading-animation span {\n  display: block;\n  position: absolute;\n  width: 3rem;\n  height: 3rem;\n  border: 0.5rem solid var(--clr-primary);\n  border-radius: 50%;\n  border-color: var(--clr-primary) transparent transparent transparent;\n}\n\n.loading-container-text.h-full {\n  height: 100vh;\n}\n\n@keyframes loading-animation {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.skeleton-card {\n  background-color: #fff5;\n  height: 2rem;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n  border-radius: 1em;\n}\n\n.skeleton::after,\n.skeleton-card::after {\n  display: block;\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  transform: translateX(-100%);\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    from(transparent),\n    color-stop(rgba(255, 255, 255, 0.74)),\n    to(transparent)\n  );\n\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.74),\n    transparent\n  );\n\n  animation: loadingSkeleton 0.8s infinite;\n}\n\n.skeleton {\n  background: #efefef70;\n  width: 7rem;\n  height: 1rem;\n  border-radius: 0.5em;\n  overflow: hidden;\n  position: relative;\n  margin-top: 0.7rem;\n}\n\n@keyframes loadingSkeleton {\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n/* google mAPS\n\n.gm-style .gm-style-iw-t {\n  bottom: 4rem !important;\n}\n\n*/\n\n.gm-ui-hover-effect,\n.gm-ui-hover-effect > span {\n  display: none !important;\n}\n\n/* MANSORY */\n.my-masonry-grid {\n  display: -webkit-box; /* Not needed if autoprefixing */\n  display: -ms-flexbox; /* Not needed if autoprefixing */\n  display: flex;\n  width: auto;\n}\n.my-masonry-grid_column {\n  padding-left: 30px; /* gutter size */\n  background-clip: padding-box;\n}\n\n/* Style your items */\n.my-masonry-grid_column > div {\n  /* change div to reference your elements you put in <Masonry> */\n  margin-bottom: 30px;\n}\n\n.loading-dot {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.loading-dot span {\n  width: 8px;\n  height: 8px;\n  background: #0003;\n  border-radius: 50%;\n  margin: 0 0.25rem;\n}\n\n.loading-dot span:first-child {\n  animation: loadingDotAnimation1 1s infinite;\n}\n.loading-dot span:nth-child(2) {\n  animation: loadingDotAnimation2 1s infinite;\n}\n.loading-dot span:nth-child(3) {\n  animation: loadingDotAnimation3 1s infinite;\n}\n\n@keyframes loadingDotAnimation1 {\n  0% {\n    opacity: 0.25;\n  }\n  30% {\n    opacity: 1;\n  }\n}\n@keyframes loadingDotAnimation2 {\n  30% {\n    opacity: 0.25;\n  }\n  60% {\n    opacity: 1;\n  }\n}\n@keyframes loadingDotAnimation3 {\n  60% {\n    opacity: 0.25;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.thumbs-wrapper {\n  display: none;\n}\n\n.carousel-status {\n  visibility: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
